import AutoCompleteField from '@Fields/AutoCompleteField';
import SelectField from '@Fields/SelectField';
import TextField from '@Fields/TextField';
import ModalSerialVinSpecsForm from '@Forms/ModalSerialVinSpecsForm';
import LocationPickerField from '@Fields/LocationPickerField';
import MuiAutocomplete from '@mui/material/Autocomplete';
import PriceSection from '@Sections/PriceSection';

class ListingDetailForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.UpdateCategoryList = this.UpdateCategoryList.bind(this);
        this.UpdateInventoryTypeAfterCategorySelection = this.UpdateInventoryTypeAfterCategorySelection.bind(this);
        this.handleOnBlurUpdate = this.handleOnBlurUpdate.bind(this);
        this.UpdateSpecList = this.UpdateSpecList.bind(this);
        this.UpdateSpecsViewModel = this.UpdateSpecsViewModel.bind(this);
        this.GetDefaultSpecs = this.GetDefaultSpecs.bind(this);
        this.GetSerialVINListingDetails = this.GetSerialVINListingDetails.bind(this);
        this.GetSerialVINSpecs = this.GetSerialVINSpecs.bind(this);
        this.SerialVinSpecAjaxCheck = this.SerialVinSpecAjaxCheck.bind(this);
        this.handleSerialVinSelectorKeyDown = this.handleSerialVinSelectorKeyDown.bind(this);
        this.focusSerialVinOption = this.focusSerialVinOption.bind(this);

        this.state = props.model;
        this.state.bAutofillRendered = false;
        this.state.bCatCanBeFilledFromMLModel = false;
    }

    //will execute this after the intial set state has recieved all props 
    componentDidMount() {
        var state = this.state; //this.ValidFECategory({ ...this.state });
        this.SNIsRequired(state, true);
        if (this.state.CategorySelected > 0) {
            this.setState({
                ...this.state,
                CategoryDisplay: this.state.CategoriesList.find((element) => { return element.Value === this.state.CategorySelected })
            });
        }
        this.CheckCatRequirements(state);
    }

    //will execute this when the state is updated
    componentDidUpdate(prevProps, prevState) {
        if (prevState.CategorySearch != this.state.CategorySearch) {
            var inputValue = this.state.CategorySearch;
            var newCats = this.state.CategoriesList;
            var objectToSend = {};
            if (this.state.CurrentSite == "MarketBook" || this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") {
                objectToSend = {
                    typedText: inputValue,
                    IsAttachment: this.state.IsAttachment,
                    Manufacturer: this.state.ManufacturerSelected,
                    Model: this.state.ModelSelected,
                    languageID: this.state.languageID,
                    isAllCats: this.state.isAllCats,
                    BaseCategoryID: this.state.InventoryType
                };
            }
            else {
                objectToSend = {
                    typedText: inputValue,
                    IsAttachment: this.state.IsAttachment,
                    Manufacturer: this.state.ManufacturerSelected,
                    Model: this.state.ModelSelected,
                    isAllCats: this.state.isAllCats,
                    languageID: this.state.languageID,
                };
            }

            var xhr3 = new XMLHttpRequest();
            xhr3.onload = function () {
                if (xhr3.status == 200) {
                    var response = JSON.parse(xhr3.response);
                    newCats = response.catDropDownOptions
                    var autofilledFields = this.state.AutofilledFields;
                    if (this.state.bCatCanBeFilledFromMLModel) {
                        if (newCats.filter(function (cat) { return cat.Value != "0" && cat.Enabled; }).length == 1) {
                            autofilledFields.push("Category");
                        }
                    }
                    //the correct way to update state don't want to mutate state
                    this.setState({
                        ...this.state,
                        CategoriesList: newCats,
                        AutofilledFields: autofilledFields,
                    });
                }
            }.bind(this);

            xhr3.open("POST", '/listinginput/ajax/SearchCatList', true);
            xhr3.setRequestHeader("Content-type", "application/json");
            xhr3.send(JSON.stringify(objectToSend));
        }
        // a different cat was selected update the displayed cat
        else if (this.state.CategorySelected > 0) {
            var newCat = this.state.CategoriesList.find((element) => { return element.Value === this.state.CategorySelected });
            if (newCat != undefined) {
                if (prevState.CategoryDisplay == undefined || (prevState.CategoryDisplay.Value !== newCat.Value)) {
                    //only call the update spec method if we autofilled from ML
                    if (this.state.MLAutofilled) {
                        this.setState({
                            ...this.state,
                            CategoryDisplay: this.state.CategoriesList.find((element) => { return element.Value === this.state.CategorySelected }),
                        }, () => {
                            this.UpdateSpecList(this.state);
                        });
                    }
                    else {
                        this.setState({
                            ...this.state,
                            CategoryDisplay: this.state.CategoriesList.find((element) => { return element.Value === this.state.CategorySelected })
                        });
                    }
                }
            }
        }

        if ((this.state.CurrentSite == "MarketBook" || this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") && this.state.InventoryType == 0 && this.state.BaseCatID != 0) {
            this.setState({ ...this.state, InventoryType: this.state.BaseCatID });
        }

        if (this.state.MLAutofilled && prevState.ModelSelected != this.state.ModelSelected) {
            this.setState({ ...this.state, bCatCanBeFilledFromMLModel: true });
            this.UpdateCategoryList(this.state)
        }
    }

    componentWillReceiveProps(Props) {
        this.setState({
            CategorySelected: Props.model.CategorySelected,
            CategoriesList: Props.model.CategoriesList,
            BaseCatID: Props.model.BaseCatID,
            ManufacturerSelected: Props.model.ManufacturerSelected,
            ModelSelected: Props.model.ModelSelected,
            SerialVIN: Props.model.SerialVIN,
            YearSelected: Props.model.YearSelected,
            ConditionList: Props.model.ConditionList,
            validFECat: Props.model.validFECat,
            FleetEvalElement: Props.model.FleetEvalElement,
            MakeOnlyCategoryOptions: Props.model.MakeOnlyCategoryOptions,
            allCategoryOptions: Props.model.allCategoryOptions,
            InventoryType: Props.model.InventoryType,
            BaseCatID: Props.model.BaseCatID,
            specsViewModel: Props.specsViewModel,
            HighlightErrors: Props.model.HighlightErrors,
            FormErrors: Props.model.FormErrors,
            InputErrors: Props.model.InputErrors,
            MLAutofilled: Props.model.MLAutofilled,
            AutofilledFields: Props.model.AutofilledFields,
            IsRegisteredUser: Props.model.IsRegisteredUser,
            EmailVerified: Props.model.EmailVerified
        });
    }

    handleFormUpdate(Model) {
        this.setState({
            specsViewModel: Model.specsViewModel,
            SystemOfMeasurement: Model.SystemOfMeasurement,
            ManufacturerSelected: Model.ManufacturerSelected,
            ManufacturersList: Model.ManufacturersList,
            ModelSelected: Model.ModelSelected,
            ModelList: Model.ModelList,
            CategorySelected: Model.CategorySelected,
            CategoriesList: Model.CategoriesList,
            CategorySearch: Model.CategorySearch,
            allCategoryOptions: Model.allCategoryOptions,
            MakeOnlyCategoryOptions: Model.MakeOnlyCategoryOptions,
            SerialVIN: Model.SerialVIN,
            SNRequired: Model.SNRequired,
            SerialVINSelection: Model.SerialVINSelection,
            AllYears: Model.AllYears,
            YearSelected: Model.YearSelected,
            Years: Model.Years,
            EquipmentIdentifier: Model.EquipmentIdentifier,
            StockNumber: Model.StockNumber,
            Condition: Model.Condition,
            ConditionList: Model.ConditionList,
            Description: Model.Description,
            BaseCatID: Model.BaseCatID,
            Quantity: Model.Quantity,
            Weight: Model.Weight,
            FleetEvalElement: Model.FleetEvalElement,
            ValidFECategories: Model.ValidFECategories,
            validFECat: Model.validFECat,
            ShowFE: Model.ShowFE,
            VinSerialVerify: Model.VinSerialVerify,
            bManufacturerIsRequired: Model.bManufacturerIsRequired,
            bModelIsRequired: Model.bModelIsRequired,
            bYearIsRequired: Model.bYearIsRequired,
            bAllowModalToShow: Model.bAllowModalToShow || null,
            modalObject: Model.modalObject || null,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            bLookupButtonWasPressed: Model.bLookupButtonWasPressed || false,
            isAllCats: Model.isAllCats,
            BaseCatID: Model.BaseCatID,
            InventoryType: Model.InventoryType,
            MLAutofilled: Model.MLAutofilled,
            AutofilledFields: Model.AutofilledFields
        });
    }

    handleFieldChanged(field, value, updateCat) {
        var state = this.state;
        state[field] = value;

        switch (field) {
            case "ManufacturerSelected":
                //if we have a value and its at least 2 characters
                if (state.ManufacturerSelected != null && state.ManufacturerSelected.length >= 2) {
                    var objectToSend = {
                        Manufacturer: state.ManufacturerSelected,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID
                    };

                    var xhr1 = new XMLHttpRequest();
                    xhr1.onload = function () {
                        state = this.state;
                        if (xhr1.status == 200) {
                            var response = JSON.parse(xhr1.response);

                            state.ManufacturerSelected = this.state.ManufacturerSelected;
                            //if the responding typed text matches the current inputted manu value, update the available manu list
                            if (response.TypedText == state.ManufacturerSelected) {
                                state.ManufacturersList = response.Manufacturers;
                                //not fresh data so use existing values
                            }
                            else {
                                state.ManufacturersList = this.state.ManufacturersList;
                            }

                            if (updateCat) state = this.UpdateCategoryList(state); else this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr1.open("POST", '/listinginput/ajax/UpdateManufacturerList', true);
                    xhr1.setRequestHeader("Content-type", "application/json");
                    xhr1.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ManufacturerSelected = this.state.ManufacturerSelected;
                    state.ManufacturersList = [];
                }

                //if the manu field is cleared, reset the available category options
                if (state.ManufacturerSelected == "") {
                    state.CategoriesList = state.allCategoryOptions;
                    this.props.handleCategoryUpdate(state);

                    //if the model is also cleared, reset the years
                    if (state.ModelSelected == "") {
                        state.Years = state.AllYears;
                    }
                }

                if (state.AutofilledFields.includes("Manufacturer")) {
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Manufacturer"; });
                }

                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                this.UpdateSpecsViewModel(this.state.specsViewModel);
                break;
            case "ModelSelected":
                //if we have both a manufacturer and model chosen, and the length of both is longer than 1
                if (state.ManufacturerSelected != null && state.ManufacturerSelected.trim() != "" && state.ManufacturerSelected.length >= 2 && state.ModelSelected != null && state.ModelSelected.trim() != "" && state.ModelSelected.length >= 2) {
                    var objectToSend = {
                        Model: state.ModelSelected,
                        Manufacturer: state.ManufacturerSelected,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                        SerialVIN: state.SerialVIN,
                        EquipmentIdentifier: state.EquipmentIdentifier
                    };

                    var xhr2 = new XMLHttpRequest();
                    xhr2.onload = function () {
                        state = this.state;
                        if (xhr2.status == 200) {
                            var response = JSON.parse(xhr2.response);

                            state.ModelSelected = this.state.ModelSelected;
                            //if the typed text matches the current model selected value, update the ModelList options to be the response value
                            if (response.TypedText == state.ModelSelected) {
                                state.ModelList = response.Models;
                                //where the text doesn't match we know this isn't the "freshest" data, so use the existing values
                            }
                            else {
                                state.ModelList = this.state.ModelList;
                            }

                            if (updateCat) state = this.UpdateCategoryList(state); else this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr2.open("POST", '/listinginput/ajax/UpdateModelList', true);
                    xhr2.setRequestHeader("Content-type", "application/json");
                    this.UpdateSpecsViewModel(this.state.specsViewModel);
                    xhr2.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ModelList = [];
                }

                //if no manu or model are selected, reset the available years to all years and if in RVU clear the cat since the user can't do it themselves
                if (state.ModelSelected == "" && state.ManufacturerSelected == "") {
                    state.Years = state.AllYears;
                    if (state.CurrentSite != "RVUniverse") {
                        state.categoryddl = state.allCategoryOptions;
                    }
                }

                if (state.AutofilledFields.includes("Model")) {
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Model"; });
                }

                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                this.UpdateSpecsViewModel(this.state.specsViewModel);
                break;
            case "CategorySelected":
                //state = this.ValidFECategory(state);
                state = this.SNIsRequired(state);
                //only for AT and MBK
                if (state.CurrentSite == "MarketBook" || state.CurrentSite == "AuctionTime" || state.CurrentSite == "AuctionValues") {
                    state = this.UpdateInventoryTypeAfterCategorySelection(state);
                }
                if (state.CurrentSite == "Truck Paper" && !IsNullOrWhiteSpace(state.CategorySelected)) {
                    state = this.UpdateBaseCategoryIDForQuantityField(state);
                }

                //Make the specs section start over
                if ($(".toggle-details-2").is(":visible")) {
                    AdditionalDetailsToggle(true)
                }

                //if that field has an error, remove it until they validate again.
                if (state.HighlightErrors[field] == true) {
                    delete state.HighlightErrors[field];
                    delete state.InputErrors[field];

                    //year/serialVin form error case
                    if (field == "SerialVIN" || field == "YearSelected") {
                        state.FormErrors = [];
                    }

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors,
                        FormErrors: state.FormErrors
                    });
                }

                if (state.AutofilledFields.includes("Category") && state.bAutofillRendered) {
                    state = this.UpdateInventoryTypeAfterCategorySelection(state);
                    state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != "Category"; });
                }

                this.CheckCatRequirements(state);
                this.UpdateSpecList(state);

                break;
            case "YearSelected":
            case "SerialVIN":
                //for dropdowns and radios to update object xml
                //if that field has an error, remove it until they validate again.
                if (state.HighlightErrors[field] == true) {
                    delete state.HighlightErrors["YearSelected"];
                    delete state.InputErrors["YearSelected"];
                    delete state.HighlightErrors["SerialVIN"];
                    delete state.InputErrors["SerialVIN"];

                    state.FormErrors = [];

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors,
                        FormErrors: state.FormErrors
                    }, function () {
                        this.props.handleFormUpdate(this.state);
                    });
                }
                else {
                    let sFieldName = field == "YearSelected" ? "Year" : "SerialVIN";
                    if (state.AutofilledFields.includes(sFieldName)) {
                        state.AutofilledFields = state.AutofilledFields.filter(function (s) { return s != sFieldName; });
                    }
                    this.props.handleFormUpdate(state);
                }

                break;
            case "InventoryType":
                var objectToSend = {
                    BaseCatID: state.InventoryType,
                    ManufacturerSelected: state.ManufacturerSelected,
                    ModelSelected: state.ModelSelected,
                    CategorySelected: state.CategorySelected
                };

                var xhr1 = new XMLHttpRequest();
                xhr1.onload = function () {
                    var response = JSON.parse(xhr1.response);

                    state.CategorySelected = response.oListingDetailViewModel.CategorySelected;
                    state.CategoriesList = response.oListingDetailViewModel.CategoriesList;
                    state.allCategoryOptions = response.oListingDetailViewModel.AllCategoriesList;
                    state.BaseCatID = response.oListingDetailViewModel.BaseCatID;
                    this.props.handleCategoryUpdate(state);
                }.bind(this);

                xhr1.open("POST", '/listinginput/ajax/UpdateInventoryType', true);
                xhr1.setRequestHeader("Content-type", "application/json");
                xhr1.send(JSON.stringify(objectToSend));

                this.props.handleCategoryUpdate(state);

                break;
            case "SystemOfMeasurement":
            case "Condition":
                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                break;
            case "SpecField":
                var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];

                state.specsViewModel = this.state.specsViewModel;
                state.specsViewModel.FormInputs[spec.SpecField].Value = value;
                this.handleFormUpdate(state);

                break;
            case "SpecUnit":
                var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];

                state.specsViewModel = this.state.specsViewModel;
                state.specsViewModel.FormInputs[spec.SpecField + "unit#"].Value = value;

                state.specsViewModel = this.props.showUnitSwitchModal(state.specsViewModel, spec, spec.SpecField + "unit#", value);

                state.specsViewModel = state.specsViewModel;
                state.specsViewModel.InputErrors = {};
                state.specsViewModel.HighlightErrors = {};
                this.handleFormUpdate(state);
                this.props.handleMasterViewUpdate(state);
                break;
            case "Quantity":
                //if that field has an error, remove it until they validate again.
                if (state.HighlightErrors[field] == true) {
                    delete state.HighlightErrors["Quantity"];
                    delete state.InputErrors["Quantity"];

                    state.FormErrors = [];

                    this.setState({
                        HighlightErrors: state.HighlightErrors,
                        InputErrors: state.InputErrors,
                        FormErrors: state.FormErrors
                    }, function () {
                        this.props.handleFormUpdate(this.state);
                    });
                }
                else {
                    this.props.handleFormUpdate(state);
                }
                break;
            default:
                this.handleFormUpdate(state);
                break;
        }
    }

    handleOnBlur(field, e, updatedManu = null) {
        var state = this.state;
        var propsModel = this.props.model;

        if (field == "ManufacturerSelected" && (propsModel[field] != state[field] || updatedManu)) {
            if (e.target.value) {
                var value = e.target.value.toUpperCase();
                if (updatedManu) {
                    value = updatedManu;
                }
                state[field] = value;
                this.setState({
                    [field]: value,
                }, function () {
                    //update category list
                    if (this.state.bLookupButtonWasPressed) {
                        this.GetSerialVINListingDetails(this.state, this.state[field]);
                    }
                    this.GetDefaultSpecs(this.state);
                });
            }
        }

        if (field == "ModelSelected") {
            if (e.target.value) {
                var value = e.target.value.toUpperCase();
                state[field] = value;
                this.setState({
                    [field]: value,
                }, function () {
                    var bHasModal = !!(this.state.modalObject) && this.state.modalObject.ShowModal;
                    //only get the default specs if NO modal is present. If it is we call this function from there
                    if (!bHasModal) {
                        //update category list
                        this.UpdateCategoryList(this.state, true, true);
                        this.GetDefaultSpecs(this.state);
                        // RVUniverse doesn't have a cat drop down, always update the specs on blur for RVU
                        if (state.CurrentSite.toLowerCase() == "rvuniverse") {
                            this.UpdateSpecList(state);
                        }
                    }
                });
            }
        }

        if (field == "YearSelected") {
            if (e.target.value) {
                var value = e.target.value.toUpperCase();
                state[field] = value;
                this.setState({
                    [field]: value,
                }, function () {
                    this.GetDefaultSpecs(this.state);
                });
            }
        }

        if (field == "SpecField") {
            //mileage/hours spec options
            var spec = {};

            //don't even bother if we have empty category or empty specs
            if (this.state.CategorySelected != "0" && this.state.specsViewModel.oMMMCategoryGroupSpecs.length > 0 && this.state.specsViewModel.GroupIndex >= 0) {
                var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];

                //the spec validation is async but doesn't make the page wait for the validation unlike the other calls to this method
                this.props.ValidateSpec(spec, this.state.specsViewModel, (validatorObject) => {

                    //highilight specs error.
                    if (Object.keys(validatorObject.inputErrors).length != 0 && validatorObject.correctSpecValue == null || validatorObject.correctSpecValue == "") {

                        state.HighlightErrors[spec.SpecField] = validatorObject.highlightErrors[spec.SpecField];
                        state.InputErrors[spec.SpecField] = validatorObject.inputErrors[spec.SpecField];

                        this.setState({
                            HighlightErrors: state.HighlightErrors,
                            InputErrors: state.InputErrors,
                            FormErrors: state.FormErrors,
                        });
                    }
                    else {
                        if (validatorObject.correctSpecValue != null && validatorObject.correctSpecValue != "") {
                            state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex] = validatorObject.correctSpecValue;
                        }

                        delete state.HighlightErrors[spec.SpecField];
                        delete state.InputErrors[spec.SpecField];

                        this.setState({
                            HighlightErrors: state.HighlightErrors,
                            InputErrors: state.InputErrors,
                            FormErrors: state.FormErrors,
                        });

                        state.specsViewModel = state.specsViewModel;
                        state.specsViewModel.InputErrors = {};
                        state.specsViewModel.HighlightErrors = {};
                        this.props.handleMasterViewUpdate(state);
                    }
                });
            }
        }

        if (field == "Quantity") {
            var onlyNumbers = /^[0-9.,]+$/.test(state.Quantity);
            if (!onlyNumbers && state.Quantity != "") {
                state.HighlightErrors.Quantity = true;
                state.InputErrors.Quantity = state.Translations["MustNumber"].replace("{0}", this.state.Translations["Quantity"]);
                bHasErrors = true;
            }
            else {
                delete state.HighlightErrors["Quantity"];
                delete state.InputErrors["Quantity"];
            }
        }

        //if that field has an error, remove it until they validate again.
        if (state.HighlightErrors[field] == true) {
            delete state.HighlightErrors[field];
            delete state.InputErrors[field];

            //year/serialVin form error case
            if (field == "SerialVIN" || field == "YearSelected") {
                state.FormErrors = [];
            }

            this.setState({
                HighlightErrors: state.HighlightErrors,
                InputErrors: state.InputErrors,
                FormErrors: state.FormErrors,
            });
        }

        if (propsModel[field] != state[field]) {
            if (e) {
                var targetValue = e.target.value;
                this.props.handleFormUpdate(state);
            }
        }
    }

    handleOnBlurUpdate(e) {
        var state = this.state;
        if (e.target.id == "serialvin" && this.state.SerialVIN == "") {
            state.Years = state.AllYears;
        }
        if (e.target.id == "Description") {
            // check for illegal characters here and remove them so that the description can save properly
            // the regex removes characters with hex values from x00-x1F, ommitting horizontal/vertical tab and newline. there was an issue where a user provided a description with the x02 character and it corrupted data
            state.Description = e.target.value.replace(/[\x00-\x08\x0E-\x1F]/g, "");
        }
        this.props.handleFormUpdate(state);
    }

    handleButtonClickOnForm(button) {
        var state = this.state;

        switch (button) {
            case "allCats":
                state.CategoriesList = state.allCategoryOptions;
                this.state.isAllCats = true
                //for mobile, remove the hover color
                var btn = document.getElementById("allcats");
                btn.classList.remove("hover");

                this.props.handleCategoryUpdate(state);
                break;
            case "serialvin":
                state.bLookupButtonWasPressed = true;
                this.GetSerialVINListingDetails(state);
                break;
        }
    }

    //call to serialvin api.
    GetSerialVINListingDetails(state, updatedManufacturer) {
        var highlightErrors = {};
        var formErrors = [];
        var inputErrors = {};

        //pass in serialvin and basecat into
        if (state.SerialVIN != null && state.SerialVIN != "") {
            //only take values that are a-z or 0-9
            var regexp = new RegExp("^[0-9A-Za-z.-]+$");
            //if we have something that's not whitespace, and it's only characters between a-z and 0-9
            if (/\S/.test(state.SerialVIN.trim()) && regexp.test(state.SerialVIN.trim())) {
                //if the lookup button hasn't been pressed then don't continue w/ the lookup
                if (!state.bLookupButtonWasPressed) {
                    return;
                }

                //show the loading icon
                Spinner.Show($('#pagebody'), true);

                var objectToSend = {
                    SerialVIN: state.SerialVIN,
                    EquipmentIdentifier: state.EquipmentIdentifier,
                    ManufacturerSelected: updatedManufacturer || state.ManufacturerSelected
                };

                var xhr3 = new XMLHttpRequest();
                xhr3.onload = function () {
                    var oldCatgorySelected = state.CategorySelected; //checks if we got a new category selected, and see if we should look for specs immediately
                    state = this.state;
                    var response = JSON.parse(xhr3.response);

                    //if there is a result, set the values. Otherwise, display to user that there was not a match
                    if (response.oListingDetailViewModel.ManufacturerSelected != null && response.oListingDetailViewModel.ManufacturerSelected != "") {
                        state.HighlightErrors = {};
                        state.InputErrors = {};
                        state.FormErrors = [];

                        //if the response has a suggested value then use that, otherwise use what the page currently holds
                        state.ManufacturerSelected = response.oListingDetailViewModel.ManufacturerSelected == "" ? state.ManufacturerSelected : response.oListingDetailViewModel.ManufacturerSelected;
                        state.ModelSelected = response.oListingDetailViewModel.ModelSelected == "" ? state.ModelSelected : response.oListingDetailViewModel.ModelSelected;
                        state.YearSelected = response.oListingDetailViewModel.YearSelected == "" ? state.YearSelected : response.oListingDetailViewModel.YearSelected;
                        state.Years = response.oListingDetailViewModel.Years.length > 1 ? response.oListingDetailViewModel.Years : state.Years;
                        state.CategorySelected = response.oListingDetailViewModel.CategorySelected == "" ? state.CategorySelected : response.oListingDetailViewModel.CategorySelected;

                        //if no items in the returned manu list match the selected manu, then hide all the autocomplete options
                        if (!state.ManufacturersList.some((elem) => elem == state.ManufacturerSelected)) {
                            state.ManufacturersList = [];
                        }

                        if (response.oListingDetailViewModel.CategoriesList != null && response.oListingDetailViewModel.CategoriesList.length > 0) state.CategoriesList = response.oListingDetailViewModel.CategoriesList.length > 1 ? response.oListingDetailViewModel.CategoriesList : state.CategoriesList; else state = this.UpdateCategoryList(state, false);

                        delete state.InputErrors["SerialVINResults"];
                        state.bAllowModalToShow = true;
                    }
                    else {
                        inputErrors.SerialVINResults = this.getTranslation("NoResults");
                        state.bAllowModalToShow = false;
                        state.HighlightErrors = highlightErrors;
                        state.InputErrors = inputErrors;
                        state.FormErrors = formErrors;
                    }

                    Spinner.Remove();

                    this.handleFormUpdate(state);
                    this.props.handleFormUpdate(state);
                    this.props.handleCategoryUpdate(state);

                    if (this.SerialVinSpecAjaxCheck(state) && oldCatgorySelected == state.CategorySelected) {
                        this.GetSerialVINSpecs(state);
                    }
                    else if (this.SerialVinSpecAjaxCheck(state) && oldCatgorySelected != state.CategorySelected) {
                        this.UpdateSpecList(state);
                    }
                }.bind(this);

                //make the call to the endpoint to decode the machine
                xhr3.open("POST", '/listinginput/ajax/GetSerialVINListingDetails', false);
                xhr3.setRequestHeader("Content-type", "application/json");
                xhr3.send(JSON.stringify(objectToSend));
            }
            else {
                state.bAllowModalToShow = false;
                inputErrors.SerialVINResults = state.Translations["IsInvalid"].replace("{0}", this.state.Translations["SerialVIN"]);

                state.HighlightErrors = highlightErrors;
                state.InputErrors = inputErrors;
                state.FormErrors = formErrors;

                this.handleFormUpdate(state);
            }
        }
        else {
            state.bAllowModalToShow = false;
            this.handleFormUpdate(state);
        }
    }

    GetSerialVINSpecs(state) {
        var objectToSend = {
            SerialVIN: state.SerialVIN,
            EquipmentIdentifier: state.EquipmentIdentifier,
            Manufacturer: state.ManufacturerSelected,
            Model: state.ModelSelected,
            Category: state.CategorySelected,
            FormInputs: state.specsViewModel.FormInputs,
            ObjectXMLInputs: state.specsViewModel.ObjectXMLInputs
        };

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response;
            if (xhr.status == 200) {
                var response = JSON.parse(xhr.response);
            }
            else {
                return;
            }

            //check if specmodal has updates
            if (response.oSpecsViewModel.oSpecsModal.length > 0) {
                var modalObject = {};
                modalObject.ShowModal = true;
                modalObject.SerialVinResults = response.oSpecsViewModel;

                this.setState({
                    modalObject: modalObject
                });
            }

            this.setState({
                bAllowModalToShow: false
            });
        }.bind(this);

        xhr.open("POST", '/listinginput/ajax/GetSerialVinSpecs', false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    /* Returns a boolean if we have the necessary parameters to do the SerialVin Spec AJax call */
    SerialVinSpecAjaxCheck(state) {
        if (state.bModelIsRequired)
            return state.bAllowModalToShow && !IsNullOrWhiteSpace(state.SerialVIN) && !IsNullOrWhiteSpace(state.ManufacturerSelected) && !IsNullOrWhiteSpace(state.ModelSelected) && !IsNullOrWhiteSpace(state.CategorySelected) && state.CategorySelected != "0";
        else
            return state.bAllowModalToShow && !IsNullOrWhiteSpace(state.SerialVIN) && !IsNullOrWhiteSpace(state.ManufacturerSelected) && !IsNullOrWhiteSpace(state.CategorySelected) && state.CategorySelected != "0";
    }

    ValidFECategory(state) {

        //if the cat id is a valid FE category, highlight year and VIN
        var catid = parseInt(state.CategorySelected, 10);

        if (state.ValidFECategories.indexOf(catid) > -1 && state.ShowFE) {
            state.validFECat = true;

            var newElement = [];
            newElement.push(<div className="recommended-specs center-content"><span key="fleetEvalElement" className="recommended-specs center-content">{this.getTranslation("RecommendSpecs")}"<div className="fe-indicator"></div>" </span></div>);
            state.FleetEvalElement = newElement;
        }
        else {
            state.validFECat = false;
            var newElement = [];
            newElement.push(<span key="fleetEvalElement" className="no-recommended-specs center-content" style={{ display: 'none' }}> </span>);
            state.FleetEvalElement = newElement;
        }

        return state;
    }

    SNIsRequired(state, async) {
        if (state.CategorySelected != "" && state.CategorySelected.trim() != "0") {
            var objectToSend = {
                sCategory: state.CategorySelected,
            };

            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var response = JSON.parse(xhr.response);
                state.SNRequired = response.bRequiresSN;
                if (async) this.props.handleFormUpdate(state);
            }.bind(this);

            xhr.open("POST", '/listinginput/ajax/CategoryRequiresSN', async);
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.send(JSON.stringify(objectToSend));
        }
        else {
            if (this.state.CurrentSite == "Controller" ||
                this.state.CurrentSite == "Aviation Trader" ||
                this.state.CurrentSite == "Controller EMEA") {
                state.SNRequired = true;
                if (async) this.handleFormUpdate(state);
            }
            else {
                state.SNRequired = false;
                if (async) this.handleFormUpdate(state);
            }
        }

        return state;
    }

    UpdateSpecList(passedState, bUndoMLAutofill) {
        var state = this.state;

        var objectToSend = {
            Manufacturer: passedState.ManufacturerSelected,
            Model: passedState.ModelSelected,
            SerialVIN: state.SerialVIN,
            Year: state.YearSelected,
            Category: passedState.CategorySelected,
            QueryString: state.QueryString,
            SystemOfMeasurement: state.SystemOfMeasurement,
            FormInputs: state.specsViewModel.FormInputs
        };

        var biggerObjectToSend = {
            oSpecsViewModel: objectToSend,
            bUndoMLAutofill: bUndoMLAutofill ?? false
        };

        var xhr2 = new XMLHttpRequest();
        xhr2.onload = function () {
            state = this.state;
            var response = JSON.parse(xhr2.response);
            this.UpdateSpecsViewModel(response.oSpecsViewModel);

            //after we get specs, if they've entered a serial vin and cliked lookup, then we'll get some specs for them
            if (this.SerialVinSpecAjaxCheck(state)) {
                state.specsViewModel = response.oSpecsViewModel;
                this.GetSerialVINSpecs(state);
            }
            // need to refresh page if translation editor is on to get the freshly injected code for the specs section
            if (this.state.IsInTranslationEditorMode) {
                location.reload();
            }
        }.bind(this);

        xhr2.open("POST", '/listinginput/specs/LoadSpecs' + state.QueryString, true);
        xhr2.setRequestHeader("Content-type", "application/json");
        xhr2.send(JSON.stringify(biggerObjectToSend));
    }

    UpdateSpecsViewModel(specsViewModel) {
        var state = this.state;
        specsViewModel.Manufacturer = state.ManufacturerSelected;
        specsViewModel.Model = state.ModelSelected;
        state.specsViewModel = specsViewModel;
        this.props.handleMasterViewUpdate(state);
    }

    GetDefaultSpecs(state) {
        //check if specs has anything and if category is 0
        if (state.CategorySelected != "" && state.CategorySelected != "0" && state.CategorySelected != null && state.specsViewModel != null && Object.keys(state.specsViewModel.FormInputs).length > 0) {
            var objectToSend = {
                Category: state.CategorySelected,
                Manufacturer: state.ManufacturerSelected,
                Model: state.ModelSelected,
                Year: state.YearSelected,
                FormInputs: state.specsViewModel.FormInputs,
                QueryString: state.QueryString
            };

            var xhr2 = new XMLHttpRequest();
            xhr2.onload = function () {
                state = this.state;

                var response;
                if (xhr2.status == 200) {
                    var response = JSON.parse(xhr2.response);
                    state.specsViewModel.FormInputs = response.oSpecsViewModel.FormInputs;
                    this.handleFormUpdate(state);
                    this.props.handleMasterViewUpdate(state);
                }
            }.bind(this);

            xhr2.open("POST", '/listinginput/ajax/GetDefaultSpecs' + state.QueryString, true);
            xhr2.setRequestHeader("Content-type", "application/json");
            xhr2.send(JSON.stringify(objectToSend));
        }
    }

    CheckCatRequirements(state) {
        var objectToSend = {
            CategorySelected: state.CategorySelected,
            QueryString: state.QueryString,
        };

        var xhr2 = new XMLHttpRequest();
        xhr2.onload = function () {
            var originalCategory = state.CategorySelected;
            var response = JSON.parse(xhr2.response);
            state = this.state;
            state.CategorySelected = originalCategory;
            state.bManufacturerIsRequired = response.bManufacturerIsRequired;
            state.bModelIsRequired = response.bModelIsRequired;
            state.bYearIsRequired = response.bYearIsRequired;
            this.props.handleCategoryUpdate(state);
        }.bind(this);

        xhr2.open("POST", '/listinginput/ajax/CheckCatRequirements' + state.QueryString, true);
        xhr2.setRequestHeader("Content-type", "application/json");
        xhr2.send(JSON.stringify(objectToSend));
    }

    UpdateCategoryList(state, bIsAsync, bCheckSerialVinSpecs) {
        //default to making this an async call if nothing passed in
        if (bIsAsync == null)
            bIsAsync = true;
        var newCategoryList = state.allCategoryOptions;
        var currentCategory = this.state.CategorySelected;

        //if all the options dont match the options for the manufacturer, use those
        if (state.allCategoryOptions != state.MakeOnlyCategoryOptions)
            newCategoryList = state.MakeOnlyCategoryOptions;

        //if we have both a manu and model
        if (state.ManufacturerSelected != null && state.ModelSelected != null) {
            var objectToSend = {};
            //pase in the base cat id if we don't have a manu yet
            if (state.ManufacturerSelected == "") {
                objectToSend = {
                    BaseCategoryID: state.BaseCatID
                };
                //pass in the manu and bcat if we don't have a model
            }
            else if (state.ModelSelected == "") {
                objectToSend = {
                    BaseCategoryID: state.BaseCatID,
                    Manufacturer: state.ManufacturerSelected
                };
                //pass everything in since we have all fields
            }
            else {
                objectToSend = {
                    BaseCategoryID: state.BaseCatID,
                    Manufacturer: state.ManufacturerSelected,
                    Model: state.ModelSelected
                };
            }

            var xhr3 = new XMLHttpRequest();
            xhr3.onload = function (e) {
                state = this.state;
                var response;
                if (xhr3.status == 200) {
                    response = JSON.parse(xhr3.response);
                }

                //we were returned multiple categories so use that as the list
                if (response.categories.length > 0 && response.categories.length != 1)
                    newCategoryList = response.categories;
                //we were only returned 1 category, and the category is real (has text)
                else if (response.categories.length == 1 && response.categories[0].Text != "")
                    newCategoryList = response.categories;

                if (newCategoryList) {
                    //if only one category fits, automatically select it.
                    var newlist = newCategoryList.filter(function (cat) {
                        return cat.Value != "0" && cat.Enabled;
                    });
                    if (response.CategoryIDToAutoSelect) {
                        state.CategorySelected = $.grep(newCategoryList, function (cat) { return cat.Value == response.CategoryIDToAutoSelect; })[0].Value;
                        state = this.SNIsRequired(state);
                        this.setState({
                            SNRequired: state.SNRequired,
                        });
                    }
                    else {
                        newlist = newCategoryList.filter(function (cat) {
                            return currentCategory != "0" && (cat.Value == currentCategory) && cat.Enabled;
                        });
                        if (newlist.length == 1) {
                            state.CategorySelected = newlist[0].Value;
                            state = this.SNIsRequired(state);
                            this.CheckCatRequirements(state);
                            this.setState({
                                SNRequired: state.SNRequired
                            });
                        }
                        else {
                            if (state.AutofilledFields.includes("Category") && !state.AutofilledFields.includes("Model")) {
                                this.RemoveMLAutofillData(true);
                            }
                        }
                    }
                }
                else {
                    newCategoryList = state.CategoriesList;
                }

                //state = this.ValidFECategory(state);

                //if the user did a lookup on serial or vin, then we only want to show categories that are filtered for that specific serial vin.
                if (state.bAllowModalToShow) {
                    var filteredCategoriesList = [];
                    newCategoryList.filter(function (newCat) {
                        var matchedCategory = state.CategoriesList.filter(function (cat) {
                            return cat.Value == newCat.Value;
                        });
                        if (matchedCategory.length > 0) filteredCategoriesList.push(matchedCategory[0]);
                    });

                    if (filteredCategoriesList.length > 1) state.CategoriesList = filteredCategoriesList; else {
                        state.CategoriesList = newCategoryList;
                    }
                }
                else {
                    state.CategoriesList = newCategoryList;
                }

                if (e.target.id == "ManufacturerSelected" || state.CategoriesList.length > 0 && state.CategoriesList.length != 1) {
                    if (state.CategoriesList.length > 0 && state.CategoriesList.length != 1)
                        state.MakeOnlyCategoryOptions = state.CategoriesList;
                    else if (state.CategoriesList.length == 1 && state.CategoriesList[0].Text != "")
                        state.MakeOnlyCategoryOptions = state.CategoriesList;
                    else
                        state.MakeOnlyCategoryOptions = state.allCategoryOptions;
                }

                //for marketbook or auctiontime/auctionvalues, switch inventory type
                if (state.CurrentSite == "MarketBook" || state.CurrentSite == "AuctionTime" || state.CurrentSite == "AuctionValues") {
                    if (response.nInventoryType == 0) {
                        state.InventoryType = 4;
                        state.BaseCatID = 4;
                    }
                    else {
                        state.InventoryType = response.nInventoryType;
                        state.BaseCatID = response.nInventoryType;
                    }
                    state.allCategoryOptions = response.AllCategoriesList;
                    state.CategoriesList = response.categories
                }

                if (response.bModelIsRequired != null)
                    state.bModelIsRequired = response.bModelIsRequired;

                if (bCheckSerialVinSpecs) {
                    if (this.SerialVinSpecAjaxCheck(state)) {
                        this.GetSerialVINSpecs(state);
                    }
                }

                this.props.handleCategoryUpdate(state);

                //Update Spec List
                if (currentCategory != state.CategorySelected && state.CategorySelected != "0")
                    this.UpdateSpecList(state);

                if (state.CurrentSite == "Truck Paper" && !IsNullOrWhiteSpace(state.CategorySelected)) {
                    state = this.UpdateBaseCategoryIDForQuantityField(state);
                }

            }.bind(this);

            xhr3.open("POST", '/listinginput/ajax/UpdateCategoryList', bIsAsync);
            xhr3.setRequestHeader("Content-type", "application/json");
            xhr3.send(JSON.stringify(objectToSend));
        }

        return state;
    }

    UpdateInventoryTypeAfterCategorySelection(state) {
        if (state.CategorySelected != "0") {
            var objectToSend = {
                BaseCatID: state.InventoryType,
                ManufacturerSelected: state.ManufacturerSelected,
                ModelSelected: state.ModelSelected,
                CategorySelected: state.CategorySelected
            }

            var xhr1 = new XMLHttpRequest();
            xhr1.onload = function () {
                var response = JSON.parse(xhr1.response);
                state.BaseCatID = response.oListingDetailViewModel.BaseCatID;
                state.CategorySelected = response.oListingDetailViewModel.CategorySelected;
            }.bind(this);

            xhr1.open("POST", '/listinginput/ajax/UpdateInventoryType', false);
            xhr1.setRequestHeader("Content-type", "application/json");
            xhr1.send(JSON.stringify(objectToSend));

            this.setState({
                InventoryType: state.BaseCatID.toString()
            });
        }

        return state;
    }

    UpdateBaseCategoryIDForQuantityField(state) {
        if (state.CategorySelected != "0") {
            var objectToSend = {
                CategorySelected: state.CategorySelected
            };

            var xhr1 = new XMLHttpRequest();
            xhr1.onload = function () {
                var response = JSON.parse(xhr1.response);
                state.BaseCatID = response.BaseCatID;
            }.bind(this);

            xhr1.open("POST", '/listinginput/ajax/UpdateBaseCategoryIDForQuantityField', false);
            xhr1.setRequestHeader("Content-type", "application/json");
            xhr1.send(JSON.stringify(objectToSend));

            this.setState({
                BaseCatID: state.BaseCatID,
                Quantity: 1
            });

            this.props.handleCategoryUpdate(state);
        }

        return state;
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    RemoveMLAutofillData(bResettingCategory = false) {
        var state = this.state;
        if (state.AutofilledFields.includes("SerialVIN") && !bResettingCategory) {
            state.SerialVIN = "";
            state.AutofilledFields = state.AutofilledFields.filter(item => item !== "SerialVIN");
        }
        if (state.AutofilledFields.includes("Manufacturer") && !bResettingCategory) {
            state.ManufacturerSelected = "";
            state.AutofilledFields = state.AutofilledFields.filter(item => item !== "Manufacturer");
        }
        if (state.AutofilledFields.includes("Model") && !bResettingCategory) {
            state.ModelSelected = "";
            state.AutofilledFields = state.AutofilledFields.filter(item => item !== "Model");
            if (this.state.bCatCanBeFilledFromMLModel) {
                state.CategorySelected = "";
                state.CategoryDisplay = "";
                state.CategorySearch = "";
                state.bCatCanBeFilledFromMLModel = false;
                if (state.CurrentSite == "AuctionTime" || state.CurrentSite == "AuctionValues") {
                    state.InventoryType = 4;
                    state.BaseCatID = 4;
                }
            }
            state = this.UpdateCategoryList(state);
        }
        if (state.AutofilledFields.includes("Category")) {
            state.CategorySelected = "";
            state.CategoryDisplay = "";
            state.AutofilledFields = state.AutofilledFields.filter(item => item !== "Category");
            if (state.CurrentSite == "AuctionTime" || state.CurrentSite == "AuctionValues" || state.CurrentSite == "Marketbook") {
                state.InventoryType = 4;
                state.BaseCatID = 4;
            }
        }
        if (state.AutofilledFields.includes("Year") && !bResettingCategory) {
            state.YearSelected = "";
            state.AutofilledFields = state.AutofilledFields.filter(item => item !== "Year");
        }
        if (state.AutofilledFields.length == 0) {
            state.MLAutofilled = false;
        }
        this.handleFormUpdate(state);
        this.UpdateSpecList(state, true);
    }

    focusSerialVinOption(value) {
        const targetId = value === "VIN" ? "rbVINToggleLabel" : "rbSNToggleLabel";
        const el = document.getElementById(targetId);
        if (el) el.focus();
    }

    handleSerialVinSelectorKeyDown(e, currentValue) {
        const key = e.key;
        const isToggleKey = key === " " || key === "Enter" || key === "Spacebar";
        const isArrowKey = key === "ArrowLeft" || key === "ArrowRight";

        if (!isToggleKey && !isArrowKey) return;

        e.preventDefault();

        let nextValue = currentValue;

        if (isToggleKey) {
            nextValue = currentValue;
        } else {
            // with 2 options, any arrow moves to the opposite option
            nextValue = currentValue === "SerialNumber" ? "VIN" : "SerialNumber";
        }

        this.handleFieldChanged("EquipmentIdentifier", nextValue);
        this.focusSerialVinOption(nextValue);
    }

    render() {

        let MLAutofillData = [];
        let bMLCheckForFilledFields = this.state.MLAutofilled && (this.state.AutofilledFields.includes("Manufacturer") || this.state.AutofilledFields.includes("Model") || this.state.AutofilledFields.includes("Category") || this.state.AutofilledFields.includes("Year") || this.state.AutofilledFields.includes("SerialVIN"));
        var ManufacturerHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Manufacturer") ? "autofillHighlight" : "";
        var ModelHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Model") ? "autofillHighlight" : "";
        var CategoryHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Category") && this.state.CategoryDisplay != undefined && this.state.CategoryDisplay.FullName != "" ? "autofillHighlight" : "#";
        var YearHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("Year") ? "autofillHighlight" : "";
        var SerialVINHighlighting = this.state.MLAutofilled && this.state.AutofilledFields.includes("SerialVIN") ? "autofillHighlight" : "";

        if (this.state.MLAutofilled) {
            if ((!bMLCheckForFilledFields && (this.state.CategoryDisplay == undefined || this.state.CategoryDisplay.FullName == "")) || (!bMLCheckForFilledFields && (!this.state.AutofilledFields.includes("Category") || this.state.CurrentSite == "RVUniverse"))) {
                setTimeout(() => this.setState({ MLAutofilled: false }));
                MLAutofillData = []; //remove the autofill notification section if we're not filling any fields; Also don't show category autofill info for RVU
            }
            else {
                if (this.state.bAutofillRendered != true) {
                    setTimeout(() => this.setState({ bAutofillRendered: true }));
                }
                MLAutofillData.push(<p key="MLDataOverView"><strong style={{ fontSize: "15px" }}>{this.getTranslation("AbleToAutofill")}</strong></p>);
                if (this.state.AutofilledFields.includes("SerialVIN")) {
                    MLAutofillData.push(<p key="MLDataSNVIN" style={{ margin: "0px" }}><strong>{this.getTranslation("SerialVIN")}: </strong>{this.state.SerialVIN}</p>);
                }
                if (this.state.AutofilledFields.includes("Manufacturer")) {
                    MLAutofillData.push(<p key="MLDataMake" style={{ margin: "0px" }}><strong>{this.getTranslation("Manufacturer")}: </strong>{this.state.ManufacturerSelected}</p>);
                }
                if (this.state.AutofilledFields.includes("Model")) {
                    MLAutofillData.push(<p key="MLDataModel" style={{ margin: "0px" }}><strong>{this.getTranslation("Model")}: </strong>{this.state.ModelSelected}</p>);
                }
                if (this.state.AutofilledFields.includes("Category") && this.state.CurrentSite != "RVUniverse") {
                    if (this.state.CategoryDisplay != undefined && this.state.CategoryDisplay.FullName != "") {
                        MLAutofillData.push(<p key="MLDataCat" style={{ margin: "0px" }}><strong>{this.getTranslation("Category")}: </strong>{this.state.CategoryDisplay.FullName}</p>);
                    }
                }
                if (this.state.AutofilledFields.includes("Year")) {
                    MLAutofillData.push(<p key="MLDataYear" style={{ margin: "0px" }}><strong>{this.getTranslation("Year")}: </strong>{this.state.YearSelected}</p>);
                }
                MLAutofillData.push(<p key="MLDataUndo"><button type="button" onClick={(e) => { this.RemoveMLAutofillData(); }} style={{ textDecoration: 'underline', cursor: "pointer", color: "black" }}>{this.getTranslation("UndoAutofill")}</button></p>);

                MLAutofillData =
                    <div id="MLAutofillData" style={{ backgroundColor: 'rgb(0,0,0,0.1)', margin: "0px 0px 20px 0px", padding: "5px 15px 5px 15px" }}>
                        {MLAutofillData}
                    </div>
            }
        }

        var bShowSerialVinSelector = false;

        if (this.state.CurrentSite == "MarketBook" || this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") {
            bShowSerialVinSelector = true;
        }

        var conditionddl = new Array();
        this.state.ConditionList.forEach((condition) => conditionddl.push({ text: this.state.Translations[condition], value: condition }));

        var yearddl = [];
        for (var i = 0; i < this.state.Years.length; i++) {
            yearddl.push({ text: this.state.Years[i], value: this.state.Years[i] });
        };

        var categoryddl = [];
        for (var i = 0; i < this.state.CategoriesList.length; i++) {
            categoryddl.push({ text: this.state.CategoriesList[i], value: this.state.CategoriesList[i] });
        };

        var modelddl = [];
        for (var i = 0; i < this.state.ModelList.length; i++) {
            modelddl.push({ text: this.state.ModelList[i], value: this.state.ModelList[i] });
        };

        //mileage/hours spec options
        var specOptions = [];
        //don't even bother if we have empty category or empty specs
        if (this.state.CategorySelected != "0" && this.state.specsViewModel != null && this.state.specsViewModel.oMMMCategoryGroupSpecs.length > 0 && this.state.specsViewModel.GroupIndex >= 0) {
            var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.props.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];
            var selectID = spec.SpecField + "unit#";
            var selectvalues = [];
            if (spec.DatabaseUnit != null && spec.MeasurementUnitOptions != null) {
                for (var a = 0; a < spec.MeasurementUnitOptions.length; a++) {
                    for (var b = 0; b < this.state.specsViewModel.oMMMMeasurementUnit.length; b++) {
                        if (spec.MeasurementUnitOptions[a] == this.state.specsViewModel.oMMMMeasurementUnit[b].MeasurementUnitID) {
                            selectvalues.push({ text: this.state.specsViewModel.oMMMMeasurementUnit[b].Symbol, value: this.state.specsViewModel.oMMMMeasurementUnit[b].Unit, key: this.state.specsViewModel.oMMMMeasurementUnit[b].Unit })
                            break;
                        }
                    }
                }
            }

            specOptions.push(
                spec.MeasurementUnitOptions != null ?
                    <div className="form-row cf" key="specOptions">
                        <label className="label-left" htmlFor={spec.SpecField} id={spec.SpecField + "label"}>{spec.SpecField}{spec.Required ? <span> *</span> : ""}</label>
                        <div className="input-right">
                            <div className="input-left" style={{ width: 'calc(100% - 90px)' }}>
                                <TextField
                                    type={spec.SpecDataFormat == "Number" ? "number" : null}
                                    min={spec.SpecDataFormat == "Number" ? "0" : null}
                                    feRequired={spec.RecommendedForEvaluation}
                                    id={spec.SpecField}
                                    onBlur={(e) => { this.handleOnBlur("SpecField", e); }}
                                    value={this.state.specsViewModel.FormInputs[spec.SpecField].Value}
                                    onFieldChanged={(e) => { this.handleFieldChanged("SpecField", e); }}
                                    error={this.state.HighlightErrors[spec.SpecField]}
                                    errorText={this.state.InputErrors[spec.SpecField]}
                                    hasLabel={true}
                                />
                            </div>
                            <div className="labels-right">
                                <SelectField
                                    id={selectID}
                                    value={this.state.specsViewModel.FormInputs[selectID].Value}
                                    values={selectvalues}
                                    mileage={true}
                                    onFieldChanged={(e) => { this.handleFieldChanged("SpecUnit", e); }}
                                    error={this.state.HighlightErrors[selectID]}
                                    errorText={this.state.InputErrors[selectID]}
                                    hasLabel={true}
                                    ariaLabelledBy={spec.SpecField + "label"}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    <div className="form-row cf" key="specOptions">
                        <label className="label-left" htmlFor={spec.SpecField}>{spec.Label}{spec.Required ? <span> *</span> : ""}</label>
                        <div className="input-right">
                            <TextField
                                type={spec.SpecDataFormat == "Number" ? "number" : null}
                                min={spec.SpecDataFormat == "Number" ? "0" : null}
                                feRequired={spec.RecommendedForEvaluation}
                                id={spec.SpecField}
                                onBlur={(e) => { this.handleOnBlur("SpecField", e); }}
                                value={this.state.specsViewModel.FormInputs[spec.SpecField].Value}
                                onFieldChanged={(e) => { this.handleFieldChanged("SpecField", e); }}
                                error={this.state.HighlightErrors[spec.SpecField]}
                                errorText={this.state.InputErrors[spec.SpecField]}
                                hasLabel={true}
                            />
                        </div>
                    </div>
            );
        }

        //marketbook drop down
        var baseCategoryddl = [];
        if (this.state.CurrentSite == "MarketBook" || this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") {
            let baseCategories = [];
            baseCategories.push({ text: this.state.Translations["All"], value: 0 });
            baseCategories.push({ text: this.state.Translations["ConstructionEquipment"], value: 4 });
            baseCategories.push({ text: this.state.Translations["FarmEquipment"], value: 464 });
            baseCategories.push({ text: this.state.Translations["Trucks"], value: 27 });
            baseCategories.push({ text: this.state.Translations["Trailers"], value: 28 });
            if (this.state.CurrentSite == "AuctionTime" || this.state.CurrentSite == "AuctionValues") {
                baseCategories.push({ text: this.state.Translations["Boats"], value: 173000 });
            }

            baseCategoryddl.push(
                <div className="form-row cf" key="inventoryType">
                    <label className="label-left" htmlFor="InventoryType">{this.getTranslation("InventoryType")}</label>
                    <div className="input-right">
                        <SelectField
                            feRequired={this.state.validFECat}
                            id="InventoryType"
                            value={this.state.InventoryType}
                            values={baseCategories}
                            onFieldChanged={(e) => { this.handleFieldChanged("InventoryType", e); }}
                            error={this.state.HighlightErrors.InventoryType}
                            errorText={this.state.InputErrors.InventoryType}
                            hasLabel={true}
                        />
                    </div>
                </div>
            );
        }

        var QuantityField = "";
        if (this.state.CurrentSite == "Truck Paper" && (this.state.BaseCatID == 27 || this.state.BaseCatID == 28)) {
            QuantityField =
                <div className="form-row cf" key="Quantity">
                    <label className="label-left" htmlFor="Quantity">{this.getTranslation("Quantity")}</label>
                    <div className="input-right">
                        <TextField
                            id="Quantity"
                            value={this.state.Quantity}
                            NumbersOnly={true}
                            onFieldChanged={(e) => { this.handleFieldChanged("Quantity", e); }}
                            onBlur={(e) => { this.handleOnBlur(e); }}
                            error={this.state.HighlightErrors.Quantity}
                            errorText={this.state.InputErrors.Quantity}
                            hasLabel={true}
                            type="number"
                            min="0"
                        />
                    </div>
                </div>;
        }

        var SerialVinSelector = [];
        if (bShowSerialVinSelector) {
            SerialVinSelector.push(
                <div key="serialVinSelector" className="switch-btn" style={{ marginBottom: '5px' }}>
                    <input className="switch-btn-input" id="rbSNToggle" type="radio" value="SerialNumber"
                        checked={this.state.EquipmentIdentifier == "SerialNumber" ? true : false}
                        onChange={(e) => { this.handleFieldChanged("EquipmentIdentifier", e.target.value); }} />
                    <label className="switch-btn-label" htmlFor="rbSNToggle" id="rbSNToggleLabel" tabIndex="0" onKeyDown={(e) => this.handleSerialVinSelectorKeyDown(e, "SerialNumber")}>{this.getTranslation("SerialNumber")}</label>
                    <input className="switch-btn-input" id="rbVINToggle" type="radio" value="VIN"
                        checked={this.state.EquipmentIdentifier == "VIN" ? true : false}
                        onChange={(e) => { this.handleFieldChanged("EquipmentIdentifier", e.target.value); }} />
                    <label className="switch-btn-label" htmlFor="rbVINToggle" id="rbVINToggleLabel" tabIndex="0" onKeyDown={(e) => this.handleSerialVinSelectorKeyDown(e, "VIN")}>{this.getTranslation("VIN")}</label>
                </div>
            );
        }

        const inputErrorStyles = {
            boxShadow: '0 0 5px #cc0000',
        };

        var categoryField = []
        if (this.state.CurrentSite != "RVUniverse") {
            categoryField.push(
                <div className="fe-section cf" key="category-select">
                    <div className="form-row cf category-input">
                        <label className="label-left" htmlFor="CategorySelected">{this.getTranslation("Category")} <span>*</span></label>
                        <div className="input-right">
                            <MuiAutocomplete
                                disablePortal
                                openOnFocus
                                id="CategorySelected"
                                getOptionLabel={(option) => option.FullName}
                                options={this.state.CategoriesList}
                                onChange={(e, newValue) => {
                                    if (!newValue) {
                                        newValue = { Value: "0" }
                                    }
                                    this.handleFieldChanged("CategorySelected", newValue.Value);
                                    this.setState({
                                        ...this.state,
                                        CategoryDisplay: this.state.CategoriesList.find((element) => { return element.Value === this.state.CategorySelected })
                                    });

                                }}
                                isOptionEqualToValue={(option, value) => option.Value == value.Value}
                                filterOptions={x => x}
                                value={this.state.CategoryDisplay || null}
                                onInputChange={(event, newInputValue) => {
                                    this.setState({
                                        CategorySearch: newInputValue
                                    })
                                }}
                                getOptionDisabled={(option) => !option.Enabled}
                                renderInput={(params) => {
                                    if (this.state.HighlightErrors.CategorySelected) {
                                        return (
                                            <div>
                                                <div ref={params.InputProps.ref}>
                                                    <input style={inputErrorStyles} type="text" {...params.inputProps} />
                                                </div>
                                                <div className="validationError">
                                                    <span dangerouslySetInnerHTML={{ __html: this.state.InputErrors.CategorySelected }}></span>
                                                </div>
                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <div ref={params.InputProps.ref}>
                                                <input type="text" {...params.inputProps} className={CategoryHighlighting} />
                                            </div>
                                        )
                                    }
                                }}
                                renderOption={(props, option) => {
                                    return (
                                        <div {...props} key={option.Value}>
                                            {option.Text}
                                        </div>
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <button role="link" id="allcats" className="all-cats PrimaryBGC siteFontColor" onClick={(e) => { this.handleButtonClickOnForm("allCats"); }}>{this.getTranslation("RetrieveAll")}</button>
                    <div className="tip-text-all-cats" style={{ textAlign: 'center' }}>{this.getTranslation("CantFind")}</div>
                </div>
            )
        }

        const location =
            <LocationPickerField
                key="LocationPickerField"
                getTranslation={(key) => this.getTranslation(key)}
                locationData={this.props.contactViewModel.LocationViewModel}
                onLocationChanged={(loc) => {
                    var highlightErrors = this.state.HighlightErrors;
                    var inputErrors = this.state.InputErrors;
                    delete highlightErrors.LocationPicker;
                    delete inputErrors.LocationPicker;
                    this.setState({ LocationViewModel: Object.assign(this.props.contactViewModel.LocationViewModel, loc), HighlightErrors: highlightErrors, InputErrors: inputErrors }, () => {
                        this.props.handleFormUpdate(this.state);
                        this.props.handleMasterViewUpdate(this.state)
                    });
                }}
                onValidation={(result) => {
                    var highlightErrors = this.state.HighlightErrors;
                    var inputErrors = this.state.InputErrors;
                    if (result.hasError) {
                        highlightErrors.LocationPicker = true;
                        inputErrors.LocationPicker = result.errorText;
                    } else {
                        delete highlightErrors.LocationPicker;
                        delete inputErrors.LocationPicker;
                    }
                    this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors });
                }}
                onBlur={() => { this.props.handleFormUpdate(this.state); }}
                highlightErrors={this.state.HighlightErrors}
                inputErrors={this.state.InputErrors}
                showWeeklyUpdateSubscriptionCheckbox={this.props.contactViewModel && this.props.contactViewModel.ShowWeeklyUpdateSubscriptionCheckbox}
                onReceiveEmailsChanged={(val) => { if (this.props.contactViewModel) { this.props.contactViewModel.ReceiveEmails = val; } this.props.handleMasterViewUpdate(this.state); }}
            />;

        const description =
            <div className="form-row cf" key="Description">
                <label className="label-left" htmlFor="Description">{this.getTranslation("Description")}</label>
                <div className="input-right">
                    <TextField
                        id="Description"
                        type={"textarea"}
                        value={this.state.Description}
                        onFieldChanged={(e) => { this.handleFieldChanged("Description", e); }}
                        onBlur={(e) => { this.handleOnBlurUpdate(e); }}
                        characterLimit={50000}
                        error={this.state.HighlightErrors.Description}
                        errorText={this.state.InputErrors.Description}
                        hasLabel={true}
                    />
                </div>
            </div>;

        const price =
            <PriceSection
                key="PriceSection"
                masterViewModel={this.props.masterViewModel}
                model={this.props.masterViewModel.PriceViewModel}
                handleFormUpdate={(e) => { this.props.handlePriceFormUpdate(e); }}
            />;

        let locationPriceDescription = [];

        if (this.props.masterViewModel.IsRearrangedDetailsPage) {
            locationPriceDescription.push(location);
            locationPriceDescription.push(price);
            locationPriceDescription.push(description);
        } else {
            locationPriceDescription.push(description);
            locationPriceDescription.push(location);
        }

        return (
            <form onSubmit={(e) => { e.preventDefault(); }} className="">
                <div className="validationError" style={{ textAlign: 'center' }}>
                    <span>{this.state.FormErrors}</span>
                </div>

                {MLAutofillData}

                {this.state.FleetEvalElement}

                {/*Serial VIN - Think we are going to make this field site specific*/}
                <div className="form-row cf" key="SerialVIN">
                    <label className="label-left" htmlFor="SerialVIN">{this.getTranslation("SerialVIN")}{this.state.SNRequired ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        {SerialVinSelector}
                        <div className="input-left" style={{ width: '75%' }}>
                            <TextField
                                feRequired={this.state.validFECat}
                                id="SerialVIN"
                                value={this.state.SerialVIN}
                                onFieldChanged={(e) => { this.handleFieldChanged("SerialVIN", e); }}
                                onBlur={(e) => { this.handleOnBlurUpdate(e); this.handleOnBlur("SerialVIN", e); }}
                                error={this.state.HighlightErrors.SerialVIN}
                                errorText={this.state.InputErrors.SerialVINResults}
                                hasLabel={true}
                                highlight={SerialVINHighlighting}
                            />
                        </div>

                        <button role="link" id="lookup" className="btn-right PrimaryBGC siteFontColor" onClick={(e) => { this.handleButtonClickOnForm("serialvin"); }}>{this.getTranslation("LookUp")}</button>
                    </div>
                </div>

                {/*Manufacturer*/}
                <div className="form-row cf" key="Manufacturer">
                    <label className="label-left" htmlFor="ManufacturerSelected">{this.getTranslation("Manufacturer")}{this.state.bManufacturerIsRequired !== false ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <AutoCompleteField
                            feRequired={this.state.validFECat}
                            id="ManufacturerSelected"
                            value={this.state.ManufacturerSelected}
                            values={this.state.ManufacturersList}
                            onFieldChanged={(e, updateCat) => { this.handleFieldChanged("ManufacturerSelected", e, updateCat); }}
                            onBlur={(e, updatedManu) => { this.handleOnBlur("ManufacturerSelected", e, updatedManu); }}
                            error={this.state.HighlightErrors.ManufacturerSelected}
                            errorText={this.state.InputErrors.ManufacturerSelected}
                            UseNewManuBlurEvent={true}
                            hasLabel={true}
                            highlight={ManufacturerHighlighting}
                        />
                    </div>
                </div>

                {/*Model*/}
                <div className="form-row cf" key="Model">
                    <label className="label-left" htmlFor="ModelSelected">{this.getTranslation("Model")}{this.state.bModelIsRequired ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <AutoCompleteField
                            feRequired={this.state.validFECat}
                            id="ModelSelected"
                            value={this.state.ModelSelected}
                            values={this.state.ModelList}
                            onFieldChanged={(e, updateCat) => { this.handleFieldChanged("ModelSelected", e, updateCat); }}
                            onBlur={(e) => { this.handleOnBlur("ModelSelected", e); }}
                            error={this.state.HighlightErrors.ModelSelected}
                            errorText={this.state.InputErrors.ModelSelected}
                            hasLabel={true}
                            highlight={ModelHighlighting}
                        />
                    </div>
                </div>

                {/*Year*/}
                <div className="form-row cf" key="Year">
                    <label className="label-left" htmlFor="YearSelected">{this.getTranslation("Year")}{this.state.bYearIsRequired ? <span> *</span> : ""}</label>
                    <div className="input-right">
                        <SelectField
                            feRequired={this.state.validFECat}
                            id="YearSelected"
                            value={this.state.YearSelected}
                            values={yearddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("YearSelected", e); }}
                            onBlur={(e) => { this.handleOnBlur("YearSelected", e); }}
                            error={this.state.HighlightErrors.YearSelected}
                            errorText={this.state.InputErrors.YearSelected}
                            hasLabel={true}
                            highlight={YearHighlighting}
                        />
                    </div>
                </div>

                {/*Category*/}
                {baseCategoryddl}

                {/*Category*/}
                {categoryField}

                {/*Mileage/Hours (eventual Spec Options)*/}
                {specOptions}

                {/*Quantity*/}
                {QuantityField}

                {/*Condition*/}

                <div className="form-row cf" key="Condition">
                    <label className="label-left" htmlFor="conditionddl">{this.getTranslation("Condition")}</label>
                    <div className="input-right">
                        <SelectField
                            id="conditionddl"
                            value={this.state.Condition}
                            values={conditionddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("Condition", e); }}
                            error={this.state.HighlightErrors.Condition}
                            errorText={this.state.InputErrors.Condition}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {locationPriceDescription}

                <ModalSerialVinSpecsForm
                    model={this.state.modalObject}
                    specsViewModel={this.state.specsViewModel}
                    UpdateSpecsViewModel={(specsViewModel) => { this.UpdateSpecsViewModel(specsViewModel); }}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    getDefaultSpecs={(st) => { this.GetDefaultSpecs(st); }}
                    SaveSpecsToXML={this.props.SaveSpecsToXML}
                    parentModel={this.state}
                />
            </form>
        );
    }
}

export default ListingDetailForm;
global.ListingDetailForm = ListingDetailForm;